// Verzoeken voor club en bond (fase 5 clubregister): het gesprek met de andere
// partijen over aansluiting, overstap, opzegging en geschillen. Het paneel zelf
// staat in ui/verzoeken.js en wordt ook in de eigen omgeving van een lid gebruikt.
import { getClient } from '../data/supabase.js';
import { state } from '../state.js';
import { heeft, heeftModule } from '../router.js';
import { t } from '../lib/i18n.js';
import { esc } from '../lib/format.js';
import { toonVerzoeken } from '../ui/verzoeken.js';

// Teller in het menu: verzoeken die op deze organisatie wachten (C4, public.wacht_op_mij).
export async function vernieuwTeller() {
  const el = document.getElementById('badgeVerzoeken');
  if (!el || !state.currentOrgId || !heeft('case.write')) { if (el) el.style.display = 'none'; return; }
  const { data, error } = await getClient().rpc('wacht_op_mij');
  const n = error ? 0 : Number((data || []).find(r => r.organisation_id === state.currentOrgId)?.aantal || 0);
  el.textContent = n;
  el.title = t('verz.teller', { aantal: n });
  el.style.display = n ? '' : 'none';
}

// Waarover kan deze organisatie een verzoek openen: de aansluitingen die ze heeft.
async function keuzes(client, org, alsBond) {
  const { data, error } = await client.rpc('aansluitingen_lijst', { p_org: org });
  if (error) return [];
  const gezien = new Set();
  const uit = [];
  for (const r of data || []) {
    if (alsBond) {
      uit.push({ label: r.register_naam || r.club_org_naam || '', args: {
        p_bond: org, p_club_org: r.club_org_id || null, p_club_register: r.club_register_id || null, p_affiliation: r.id } });
    } else if (!gezien.has(r.bond_id)) {
      gezien.add(r.bond_id);
      uit.push({ label: r.bond_naam, args: { p_bond: r.bond_id, p_club_org: org, p_affiliation: r.id } });
    }
  }
  return uit;
}

export async function render() {
  const el = document.getElementById('verzoekenInhoud');
  if (!el) return;
  const org = state.currentOrgId;
  const alsBond = heeftModule('bond');
  el.className = 'settings-card breed';
  await toonVerzoeken(el, getClient(), {
    schrijven: heeft('case.write'),
    openen: () => keuzes(getClient(), org, alsBond),
    zichtbaarheidKeuze: true,
    metBond: !alsBond,
    uitleg: alsBond ? 'verz.uitleg.bond' : 'verz.uitleg.club',
  });
  if (el.hidden) {
    el.hidden = false;
    el.innerHTML = `<div class="banner banner-amber"><i class="ti ti-alert-triangle"></i><span>${esc(t('verz.nietbeschikbaar'))}</span></div>`;
  }
  vernieuwTeller();
}
